module.exports = __webpack_public_path__ + "static/media/new-amazon.6e75c666.svg";